import { createModel } from '@rematch/core';
import { Experts, AvailableExamExpert } from '../../api/ApiClient';
import apiConnector from '../../api/ApiConnector';

const initState: ExpertsState = {
    expertsList: null,
    availableExpertsList: null,
};

export default createModel({
    state: initState,
    reducers: {
        setExpertsList(state: ExpertsState, expertsList: Experts | null) {
            return { ...state, expertsList };
        },
        setAvailableExpertsList(state: ExpertsState, availableExpertsList: AvailableExamExpert[] | null) {
            return { ...state, availableExpertsList };
        },
    },
    effects: (dispatch: any) => ({
        async getExpertsAsync(payload: GetExpertPayload) {
            const expertsList = await apiConnector.execApi(dispatch, apiClient => apiClient.getExperts(
                    payload.onlyQecEmployees,
                    payload.qualificationId,
                    payload.searchField,
                    payload.searchTerm,
                    payload.page,
                    payload.pageSize,
                    payload.sortOrder,
                    payload.sortField,
                ));

            if (!expertsList) return;

            this.setExpertsList(expertsList);
        },
        async getAvailableExpertsAsync(payload: IGetAvailableExamExperts) {
            const availableExpertsList = await apiConnector.execApi(dispatch, apiClient => apiClient.getAvailableExamExperts(
                payload.onlyEmployees,
                payload.qualificationId,
            ));

            this.setAvailableExpertsList(availableExpertsList);
        },
        async getExpertsByIds(expertIds: string[]) {
            if (expertIds.length === 0) {
                this.setExpertsList(null);
                return;
            }

            const experts = await apiConnector.execApi(dispatch, apiClient => apiClient.getExpertsByIds(expertIds));

            if (!experts) {
                this.setExpertsList(null);
                return;
            }

            this.setExpertsList({
                items: experts,
                page: 1,
                pageSize: experts.length,
                total: experts.length,
            });
        },
        clearExpertsList() {
            this.setExpertsList(null);
        },
    }),
});

interface ExpertsState {
    expertsList: Experts | null;
    availableExpertsList: AvailableExamExpert[] | null;
}

interface GetExpertPayload {
    qualificationId?: string;
    examId?: string;
    onlyQecEmployees?: boolean;
    onlySelected?: boolean;
    searchField?: string;
    searchTerm?: string;
    page?: number;
    pageSize?: number;
    sortOrder?: boolean;
    sortField?: string;
}

interface IGetAvailableExamExperts {
    onlyEmployees: boolean;
    qualificationId: string;
}
